module.exports = __webpack_public_path__ + "img/naftogaz.a8c32394.png";